/**
 * View component for /user-answers/new
 *
 * Creates a new userAnswer from a copy of the defaultItem in the userAnswer reducer
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { history, withRouter } from 'react-router-dom';

// import third-party libraries
import _ from 'lodash';

// import actions
import * as userAnswerActions from '../userAnswerActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import userAnswer components
import UserAnswerForm from '../components/UserAnswerForm.js.jsx';
import UserAnswerLayout from '../components/UserAnswerLayout.js.jsx';

class CreateUserAnswer extends Base {
  constructor(props) {
    super(props);
    this.state = {
      userAnswer: _.cloneDeep(this.props.defaultUserAnswer)
      // NOTE: We don't want to actually change the store's defaultItem, just use a copy
    }
    this._bind(
      '_handleFormChange'
      , '_handleFormSubmit'
    );
  }

  _handleFormChange(e) {
    /**
     * This let's us change arbitrarily nested objects with one pass
     */
    let newUserAnswerState = _.update( this.state.userAnswer, e.target.name, function() {
      return e.target.value;
    });
    this.setState({userAnswer :newUserAnswerState});
  }


  _handleFormSubmit(e) {
    const { dispatch, history } = this.props;
    e.preventDefault();
    dispatch(userAnswerActions.sendCreateUserAnswer(this.state.userAnswer)).then((action) => {
      if(action.success) {
        dispatch(userAnswerActions.invalidateList());
        history.push(`/user-answers/${action.item._id}`)
      } else {
        // console.log("Response Error:");
        // console.log(action);
        alert("ERROR - Check logs");
      }
    });
  }

  render() {
    const { userAnswer } = this.state;
    const isEmpty = (userAnswer.name === null || userAnswer.name === undefined);
    return (
      <UserAnswerLayout>
        <div className="flex">
          <section className="section">
            {isEmpty ?
              <h2> Loading...</h2>
              :
              <UserAnswerForm
                userAnswer={userAnswer}
                cancelLink="/user-answers"
                formTitle="Create User Answer"
                formType="create"
                handleFormChange={this._handleFormChange}
                handleFormSubmit={this._handleFormSubmit}
                />
            }
          </section>
        </div>
      </UserAnswerLayout>
    )
  }
}

CreateUserAnswer.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    defaultUserAnswer: store.userAnswer.defaultItem
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(CreateUserAnswer)
);



// WEBPACK FOOTER //
// modules/userAnswer/views/CreateUserAnswer.js.jsx